import { render, staticRenderFns } from "./MyGood.vue?vue&type=template&id=6fec1bf6"
import script from "./MyGood.vue?vue&type=script&lang=js"
export * from "./MyGood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports